import type { IconProps } from '.';

/**
 * Chevron Top Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const ChevronTopIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 9.70713L6.35359 15.3536L5.64648 14.6465L12 8.29292L18.3536 14.6465L17.6465 15.3536L12 9.70713Z"
      fill="white"
    />
  </svg>
);

export default ChevronTopIcon;
